import api from './api';

const ENDPOINT = 'campaign-points';

const CampaignPointService = {
  get: (params = null) => api.get(ENDPOINT, { params }),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  getByCampaign: (campaignId, params = null) =>
    api.get(`${ENDPOINT}/get-by-campaign`, {
      params: {
        ...params,
        campaignId,
      },
    }),
  getForClient: (params = null) =>
    api.get(`${ENDPOINT}/get-for-client`, {
      params: {
        ...params,
      },
    }),
};

export default CampaignPointService;
